module.exports = __webpack_public_path__ + "static/img/ezwel-renewal.ad5cfa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ezwel-renewal.jpg
// module id = QtPp
// module chunks = 0